var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.7955 5.2045C19.2348 5.64384 19.2348 6.35616 18.7955 6.7955L6.7955 18.7955C6.35616 19.2348 5.64384 19.2348 5.2045 18.7955C4.76517 18.3562 4.76517 17.6438 5.2045 17.2045L17.2045 5.2045C17.6438 4.76517 18.3562 4.76517 18.7955 5.2045Z",
    fill: "#053149"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.2045 5.2045C5.64384 4.76517 6.35616 4.76517 6.7955 5.2045L18.7955 17.2045C19.2348 17.6438 19.2348 18.3562 18.7955 18.7955C18.3562 19.2348 17.6438 19.2348 17.2045 18.7955L5.2045 6.7955C4.76517 6.35616 4.76517 5.64384 5.2045 5.2045Z",
    fill: "#053149"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseImage);
export default __webpack_public_path__ + "static/media/close-image.5f78140acfb8a902e6fb298ae8022462.svg";
export { ForwardRef as ReactComponent };